import React, { Component }from 'react';
import styled from 'styled-components';
import {S3_VIDEOS} from './video-generator.service'
import icons from "react-morph-material-icons/build/shapes";
import MorphIcon from "react-morph-material-icons";

const DetailContainer = styled.div`
    display: block;
    width: 100%;
    text-align: center;
`
const TableContainer = styled.div`
    display: block;
    width: 100%;
`
const Video = styled.video`
    width: 67%;
    height: auto;
    margin-bottom: 18px;
`
const THeader = styled.div`
  display: flex;
  flex-flow: row wrap;
  background: #3E72D7;
  color: #FFFFFF;
  font-size: 16px;
`

const Row = styled.div`
  display: flex;
  flex-flow: row wrap;
    cursor: ${props => props.pointer ? 'pointer' : 'auto'};
`

const TCell = styled.div`
    flex: 1;
    padding: 0.5em 0.5em;
    border-bottom: solid 1px rgba(0, 0, 0, .05);
    text-overflow: ellipsis;
    overflow: hidden;
    display: flex;
    justify-content: ${props => props.contentStart ? 'start' : 'center'};

    .student-name{
        text-align: initial;
    }
`;

// max-height: calc(100vh - 306px);
const TBody = styled.div`
    box-shadow: 0 1px 5px rgba(0,0,0,.1);
    color: #637381;
    font-size: 14px;
    max-height: calc(100vh - ${props => props.maxHeight}px);
    overflow-y: auto;
    width: ${props => props.overflowActive ? '101%' : '100%'};

      &::-webkit-scrollbar {
          width: 8px;
          height: 8px;
          background-color: #f1f1f1;
          border-radius: 8px;
      }
      &::-webkit-scrollbar-thumb {
          border-radius: 100px;
          background: #c1c1c1;
          &:hover{
              background: #9e9d9d
          }
      }
      &::-webkit-scrollbar-track {
          border-radius: 8px;
      }
`

const Email = styled.span`
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
`

const Warning = styled.img`
    margin-right: 7px;
    width: 15px;
    height: 17px;
`

function showIconWarning(row){
    return !row.parents.length || !row.path;
}

export default class DetailVideos extends Component {

  constructor(props) {
      super(props)
      this.state = {
        overflowActive: false,
        row: null,
        showVideo: false
      };
  }

  componentDidMount() {
    const element = this.element;
    this.setState({overflowActive: element.offsetHeight < element.scrollHeight})
  }

    handleClick = row => () =>{
        this.setState({row: row, showVideo: false}, () => {
            setTimeout(() => {
                this.setState({showVideo: true});
            }, 10);
        });
    }

    render(){
        const {data:rows, maxHeight = 480, showWarning = false} = this.props;

        var propsMorphIcon = {
            style: { fill: '#3E72D7' },
            shapes: icons.action.visibility,
            size: 17,
        };

        return (
            <DetailContainer>
                {
                    showWarning && this.state.showVideo &&
                    <Video controls autoPlay>
                        <source src={S3_VIDEOS+this.state.row.path} type="video/mp4" />Your browser does not support the video tag. I suggest you upgrade your browser.
                        <source src={S3_VIDEOS+this.state.row.path} type="video/mp4" />Your browser does not support the video tag. I suggest you upgrade your browser.
                    </Video>
                }
                <TableContainer>
                    <THeader>
                        <TCell>Alumno</TCell>
                        { rows && rows[0].parents && <TCell>Correo(s)</TCell>}
                        <TCell>Sala</TCell>
                    </THeader>
                    <TBody innerRef={(el) => {this.element = el}} overflowActive={this.state.overflowActive} maxHeight={this.state.row ? '560' : maxHeight}>
                        {
                            rows && rows.map(row => (
                                <Row key={row.id} onClick={showWarning && !showIconWarning(row) && this.handleClick(row)} pointer={showWarning && !showIconWarning(row)}>
                                    <TCell contentStart={showWarning}>
                                        {showWarning && showIconWarning(row) && <Warning src="/assets/Warning.svg"/>}
                                        {showWarning && !showIconWarning(row) && <span style={{marginRight: 7}}><img src="/assets/visibility.svg" alt="ver video" /></span>}
                                        <span className="student-name">{row.fullName}</span>
                                    </TCell>
                                    {row.parents &&
                                        <TCell style={{flexDirection: 'column'}}>
                                            {row.parents.map(parent => <Email key={parent.email}>{parent.email}</Email>)}
                                        </TCell>
                                    }
                                    <TCell>
                                        {row.classroom_name}
                                    </TCell>
                                </Row>
                            ))
                        }
                    </TBody>
                </TableContainer>
            </DetailContainer>
        )
    }

}



// WEBPACK FOOTER //
// ./src/Containers/VideoGenerator/DetailVideos.jsx